export default "__VITE_ASSET__QXVP13m$__"